import { render, staticRenderFns } from "./AppDepartmentGalleryBlock.vue?vue&type=template&id=6e73d12e&scoped=true"
import script from "./AppDepartmentGalleryBlock.vue?vue&type=script&lang=js"
export * from "./AppDepartmentGalleryBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e73d12e",
  null
  
)

export default component.exports